import { useTranslation } from "react-i18next";
import { Checkbox } from "antd";
import { Row, Col } from "antd";
import { useEffect, useState } from "react";
import { Radio } from "antd";
import { fetchClientPROPersonalitationData, editPROConfiguration } from "../../../../api/repositoryEP";
import { Button } from "antd";
import { EditPROPersonalitationDto } from "../../../../models/ConfigurationData";
import './ProConfiguration.scss';
import { LoadingOutlined } from "@ant-design/icons";
import { LoadingData } from "../../../common";
import { MuiColorInput } from "mui-color-input";
import { useAppConfig } from "../../../../Contexts/AppConfigContext";
import { set } from "lodash";

interface ProConfigurationInterface {
    languages: string[];
}

const ProConfiguration = (props: ProConfigurationInterface) => {
    const { t } = useTranslation();

    const [mainColorWeb, setMainColorWeb] = useState("");
    const [secondaryColorWeb, setSecondaryColorWeb] = useState("");
    const [mainColorWidget, setMainColorWidget] = useState(""); //este es el unico que usamos ahora mismo
    const [secondaryColorWidget, setSecondaryColorWidget] = useState("");
    const [useDefaultTemplate, setUseDefaultTemplate] = useState(false);
    const [model, setModel] = useState(0);
    const [loading, setLoading] = useState<boolean>(false)
    const [loadingButton, setLoadingButton] = useState<boolean>(false)
    const appConfig = useAppConfig();
    const { config, setConfig } = useAppConfig();



    useEffect(() => {
        setLoading(true)
        const fetchData = () => {
            fetchClientPROPersonalitationData()
                .then(response => {
                    setUseDefaultTemplate(response?.data.useDefaultTemplate);
                    setMainColorWeb(response?.data.webMainColor ?? "");
                    setMainColorWidget(response?.data.widgetMainColor ?? "");
                    setSecondaryColorWeb(response?.data.webSecondaryColor);
                    setSecondaryColorWidget(response?.data.widgetSecondaryColor ?? "");
                    setModel(response?.data.defaultTemplate);
                    setLoading(false)
                })
        };

        fetchData();
    }, []);



    const handleMainColorWeb = (e: any) => {
        setMainColorWeb(e.target.value);
    }


    const handleSecondaryColorWeb = (color: string) => {
        setSecondaryColorWeb(color);
    }


    const handleMainColorWidget = (color: string) => {
        setMainColorWidget(color);
    };


    const handleSecondaryColorWidget = (color: string) => {
        setSecondaryColorWidget(color);
    }

    const handleUseDefaultTemplate = (e: any) => {
        setUseDefaultTemplate(e.target.checked);
    };





    const saveColors = () => {
        setLoadingButton(true)

        const dto: EditPROPersonalitationDto = {
            mainColorWeb: "",
            secondaryColorWeb: "",
            secondaryColorWidget: secondaryColorWidget.startsWith("#") ? secondaryColorWidget : `#${secondaryColorWidget}`,
            mainColorWidget: mainColorWidget.startsWith("#") ? mainColorWidget : `#${mainColorWidget}`,
            // mainColorWeb: mainColorWeb.startsWith("#") ? mainColorWeb : `#${mainColorWeb}`,  // Asegurarse de que los colores tienen el formato correcto
            //  secondaryColorWeb: secondaryColorWeb.startsWith("#") ? secondaryColorWeb : `#${secondaryColorWeb}`,
            //    SecondaryColorWidget: secondaryColorWidget.startsWith("#") ? secondaryColorWidget : `#${secondaryColorWidget}`,
        }
        console.log(dto)

        editPROConfiguration(dto)
            .then(response => {
                if (response?.type === 1) {
                    const updatedConfig = {
                        ...appConfig.config,
                        mainColor: dto.mainColorWidget,

                    };
                    setConfig(updatedConfig);

                    const scrollTopElement = document.getElementById("content-page");
                    if (scrollTopElement) {
                        scrollTopElement.scrollTop = 0;
                    }

                    setLoadingButton(false);
                }
            });

    }




    return (
        <div className="pro-configuration-component">
            {loading ? (<LoadingData />) : (
                <>
                    <Row gutter={0} className="global-container">

                        <h2 className="app-title medium no-bordered">
                            {t("components.pro-configuration.title-colors")}
                        </h2>

                        <Col xs={24} md={24}>
                            <Row gutter={4} className="color-container">

                                {/*  <Col xs={12} md={6}>
                                    <span>
                                        <div className="text">
                                            {t("components.pro-configuration.main-color-web")}
                                            <ColorPicker
                                                value={mainColorWeb}
                                                onChange={handleMainColorWeb}
                                                format="hex"
                                            /> 
                                        </div>
                                    </span>
                                </Col>
                                <Col xs={12} md={6}>
                                    <span>
                                        <div className="text">
                                            {t("components.pro-configuration.secondary-color-web")}
                                            <ColorPicker
                                                value={secondaryColorWeb}
                                                onChange={handleSecondaryColorWeb}
                                                format="hex"
                                            />
                                        </div>
                                    </span>
                                </Col>
*/}
                                <Row>
                                    <Col xs={24} md={24} className="text">

                                        {t("components.pro-configuration.main-color-widget")}
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <MuiColorInput
                                            value={mainColorWidget}
                                            onChange={handleMainColorWidget}
                                            format="hex"
                                            sx={{
                                                '& .MuiInputBase-input': {
                                                    padding: '8px 16px',
                                                }
                                            }}
                                        />

                                    </Col>
                                </Row>
                                <Row>

                                    <Col xs={24} md={24} className="text">

                                        {t("components.pro-configuration.secondary-color-widget")}
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <MuiColorInput
                                            value={secondaryColorWidget}
                                            onChange={handleSecondaryColorWidget}
                                            format="hex"
                                            sx={{
                                                '& .MuiInputBase-input': {
                                                    padding: '8px 16px',
                                                }
                                            }}
                                        />

                                    </Col>

                                </Row>

                                {/*}
                                <Col xs={12} md={6}>
                                    <span>
                                        <div className="text">
                                            {t("components.pro-configuration.secondary-color-widget")}
                                            <ColorPicker
                                                value={secondaryColorWidget}
                                                onChange={handleSecondaryColorWidget}
                                                format="hex"
                                            />
                                        </div>
                                    </span>
                                </Col>
                                */}
                            </Row>
                        </Col>                  
                    </Row>
                    <Col xs={24} md={24} className="button-container" >
                        <Button className="app-button button-large" onClick={saveColors} disabled={loadingButton}>
                            {loadingButton ? <LoadingOutlined /> : t("components.button.save")}
                        </Button>
                    </Col>
                </>)}
        </div>
    );
};

export default ProConfiguration;
